export default __webpack_public_path__ + "static/media/logo.ef013187.png";